import React from 'react';

interface GoldenCrossIconProps {
  className?: string;
  title?: string;
}

const GoldenCrossIcon: React.FC<GoldenCrossIconProps> = ({ className = "w-4 h-4", title }) => {
  return (
    <>
      {/* Light mode - Light golden cross icon */}
      <img
        src="/images/golden-cross-light-icon.png"
        alt="Golden Cross"
        className={`${className} dark:hidden`}
        title={title}
      />
      {/* Dark mode - Original golden cross icon */}
      <img
        src="/images/golden-cross-icon.png"
        alt="Golden Cross"
        className={`${className} hidden dark:block`}
        title={title}
      />
    </>
  );
};

export default GoldenCrossIcon;